import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { GalleryDto } from '@nusign/picflow-backend-types';
import { objectsMatch } from '../../../lib/objects-match';
import { GalleryThemeService } from '../../../services/gallery-theme.service';
import { calcLegacyTheme } from '../../lib/calc-legacy-theme';
import { RoundedHoverBoxComponent } from '../rounded-hover-box/rounded-hover-box.component';
import { ThemeItemComponent } from '../theme-item/theme-item.component';

@Component({
  selector: 'app-theme-select-item',
  imports: [RoundedHoverBoxComponent, ThemeItemComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './theme-select-item.component.html',
  styleUrl: './theme-select-item.component.scss',
})
export class ThemeSelectItemComponent {
  private galleryThemeService = inject(GalleryThemeService);
  gallery = input.required<GalleryDto>();
  customize = output<void>();
  customThemes = toSignal(this.galleryThemeService.getCustomThemes());

  theme = computed(() => {
    const gallery = this.gallery();
    if (!gallery) return;
    return this.gallery().theme || calcLegacyTheme(this.gallery());
  });

  customTheme = computed(() => {
    const theme = this.theme();
    const customThemes = this.customThemes();
    if (!theme || !customThemes) return;
    return customThemes.find(customTheme => objectsMatch(customTheme.theme, theme)) || null;
  });
}
